import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { toast } from 'sonner';
import { Copy, QrCode } from 'lucide-react';

export default function ShareTab() {
  const publicUrl = window.location.origin;
  const catalogUrl = `${publicUrl}/catalog`;
  const qrUrl = `${process.env.REACT_APP_BACKEND_URL}/api/qr?url=${encodeURIComponent(catalogUrl)}`;

  const copyLink = () => { navigator.clipboard.writeText(catalogUrl); toast.success('Link copied'); };
  const downloadQr = async () => {
    const resp = await fetch(qrUrl);
    const blob = await resp.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'keratina-catalog-qr.png';
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-serif">Share your catalog</h2>
        <p className="text-sm text-[#3D2817]/60">Print for trade shows, send via WhatsApp, or embed on your site.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="border rounded-sm p-6 bg-white">
          <div className="text-xs uppercase tracking-widest text-[#3D2817]/60 mb-3">Public Catalog Link</div>
          <div className="flex items-center gap-2">
            <Input readOnly value={catalogUrl} data-testid="share-link" className="font-mono text-xs" />
            <Button variant="outline" size="icon" onClick={copyLink} data-testid="share-copy"><Copy className="w-4 h-4" /></Button>
          </div>
          <div className="mt-6 flex gap-2">
            <Button variant="outline" asChild>
              <a href={`https://wa.me/?text=${encodeURIComponent('Discover our Italian keratin catalog: ' + catalogUrl)}`} target="_blank" rel="noreferrer">Share on WhatsApp</a>
            </Button>
            <Button variant="outline" asChild>
              <a href={`mailto:?subject=${encodeURIComponent('Italian Keratin Catalog')}&body=${encodeURIComponent(catalogUrl)}`}>Share via Email</a>
            </Button>
          </div>
        </div>
        <div className="border rounded-sm p-6 bg-white flex flex-col items-center">
          <div className="text-xs uppercase tracking-widest text-[#3D2817]/60 mb-4 self-start">Trade Show QR</div>
          <img src={qrUrl} alt="Catalog QR code" className="w-56 h-56 border border-[#E5D9C8]" data-testid="share-qr" />
          <Button className="mt-4" onClick={downloadQr} data-testid="download-qr">
            <QrCode className="w-4 h-4 mr-2" /> Download PNG
          </Button>
        </div>
      </div>
    </div>
  );
}
